import ExternalLinkIcon from '@assets/images/icons/external-link.svg?react'
import { NewTooltip } from '@lib/components'
import { isValidHttpUrl } from '@lib/utils/strings'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import cx from 'classnames'
import type React from 'react'
import { useSelector } from 'react-redux'

import { isFigmaUrl } from '@/helpers'
import cssNode from '../../../../Node.module.scss'
import css from './Link.module.scss'

type Props = {
  url: string
}

const Link: React.FC<Props> = ({ url }) => {
  const emailPattern = /^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/

  const isEmail = emailPattern.test(url)
  const validUrl = isValidHttpUrl(url) ? url : `https://${url}`
  const newUrl = isEmail ? `mailto:${url}` : validUrl

  const isFigma = isFigmaUrl(url)
  const isFigmaEnabled = useSelector(
    migrationProjectSelector.getProjectIsFigmaEnabled
  )

  if (!isFigma || !isFigmaEnabled) {
    return (
      <NewTooltip
        content={
          <div className={css.linkTooltip}>
            {validUrl.replace(/^https?:\/\//, '')}
          </div>
        }
        renderEl={(onSetRef, onMouseEnter, onMouseLeave) => (
          <a
            ref={onSetRef}
            className={cx(cssNode.actionButton, 'node-external-link-button')}
            href={newUrl}
            target="_blank"
            rel="noopener nofollow"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          >
            <ExternalLinkIcon />
          </a>
        )}
      />
    )
  }

  return null
}

export default Link
